export function readLedger(envelope) {
  const list = envelope && envelope.processedSources;
  return Array.isArray(list) ? list : [];
}

export function isProcessed(ledger, type, id) {
  return (ledger || []).some((e) => e.type === type && String(e.id) === String(id));
}

export function mergeLedger(ledger, items, at) {
  const out = [...(ledger || [])];
  for (const it of items || []) {
    if (!isProcessed(out, it.type, it.id)) {
      out.push({ type: it.type, id: it.id, at });
    }
  }
  return out;
}

// Entries another writer (the mobile app's Master Note Accept, another tab) added to
// the stored ledger since this page last read or wrote it, added to `ours`. Entries
// this page dropped on purpose (a version restore rewinds the ledger) stay dropped:
// they are in `synced`, so they don't count as added elsewhere.
export function withLedgerAddedElsewhere(ours, stored, synced) {
  const out = [...(ours || [])];
  for (const e of stored || []) {
    if (!e || isProcessed(synced, e.type, e.id) || isProcessed(out, e.type, e.id)) continue;
    out.push(e);
  }
  return out;
}
